// Backend ile aynı canonical key'ler. UI'da label gösterilir, payload'a value gönderilir.
export const EVENT_TYPES_CANON = [
  { value: 'atolye', label: 'Atölye' },
  { value: 'konser', label: 'Konser' },
  { value: 'konferans', label: 'Konferans' },
  { value: 'stand_up', label: 'Stand-up' },
  { value: 'dj_gecesi', label: 'DJ Gecesi' },
  { value: 'tanitim', label: 'Tanıtım' },
  { value: 'kurs', label: 'Kurs' },
  { value: 'yemekli_etkinlik', label: 'Yemekli Etkinlik' },
  { value: 'diger', label: 'Diğer' },
];

export const DAYS_CANON = [
  { value: 'pazartesi', label: 'Pazartesi' },
  { value: 'sali', label: 'Salı' },
  { value: 'carsamba', label: 'Çarşamba' },
  { value: 'persembe', label: 'Perşembe' },
  { value: 'cuma', label: 'Cuma' },
  { value: 'cumartesi', label: 'Cumartesi' },
  { value: 'pazar', label: 'Pazar' },
];

export const TIME_RANGES_CANON = [
  { value: 'sabah', label: 'Sabah (08-12)' },
  { value: 'ogleden_sonra', label: 'Öğleden Sonra (12-18)' },
  { value: 'aksam', label: 'Akşam (18-22)' },
  { value: 'gece', label: 'Gece (22-02)' },
];

export const TECH_CANON = [
  { value: 'ses_sistemi', label: 'Ses Sistemi' },
  { value: 'mikrofon', label: 'Mikrofon' },
  { value: 'projeksiyon', label: 'Projeksiyon' },
  { value: 'ekran', label: 'Ekran' },
  { value: 'sahne', label: 'Sahne' },
  { value: 'isiklandirma', label: 'Işıklandırma' },
  { value: 'kayit', label: 'Kayıt' },
  { value: 'wifi', label: 'Wi-Fi' },
  { value: 'klima', label: 'Klima' },
];

export const BUDGET_MODELS_CANON = [
  { value: 'kira_yok_min_harcama', label: 'Kira yok / minimum harcama' },
  { value: 'sabit_kira_kabul', label: 'Sabit kira kabul ederim' },
  { value: 'depozito_kabul', label: 'Depozito kabul ederim' },
  { value: 'sadece_ucretsiz', label: 'Sadece ücretsiz mekân isterim' },
];

// İstanbul ilçeleri — display = value (Türkçe karakterli orijinal)
export const DISTRICTS_CANON = [
  'Adalar', 'Arnavutköy', 'Ataşehir', 'Avcılar', 'Bağcılar', 'Bahçelievler',
  'Bakırköy', 'Başakşehir', 'Bayrampaşa', 'Beşiktaş', 'Beykoz', 'Beylikdüzü',
  'Beyoğlu', 'Büyükçekmece', 'Çatalca', 'Çekmeköy', 'Esenler', 'Esenyurt',
  'Eyüpsultan', 'Fatih', 'Gaziosmanpaşa', 'Güngören', 'Kadıköy', 'Kâğıthane',
  'Kartal', 'Küçükçekmece', 'Maltepe', 'Pendik', 'Sancaktepe', 'Sarıyer',
  'Silivri', 'Sultanbeyli', 'Sultangazi', 'Şile', 'Şişli', 'Tuzla', 'Ümraniye',
  'Üsküdar', 'Zeytinburnu',
];

// Lookup helpers
const lookup = (list) => Object.fromEntries(list.map(x => [x.value, x.label]));
export const EVENT_TYPE_LABELS = lookup(EVENT_TYPES_CANON);
export const DAY_LABELS = lookup(DAYS_CANON);
export const TIME_RANGE_LABELS = lookup(TIME_RANGES_CANON);
export const TECH_LABELS = lookup(TECH_CANON);
export const BUDGET_MODEL_LABELS = lookup(BUDGET_MODELS_CANON);

// Status display
export const STATUS_LABELS = {
  taslak: 'Taslak',
  bilgi_eksik: 'Bilgi Eksik',
  analize_hazir: 'Analize Hazır',
  eslesmeye_hazir: 'Eşleşmeye Hazır',
  admin_incelemesinde: 'Admin İncelemesinde',
  eslesti: 'Eşleşti',
  arsivde: 'Arşivde',
};

export const STATUS_COLORS = {
  taslak: 'bg-zinc-200 text-zinc-700',
  bilgi_eksik: 'bg-amber-100 text-amber-800 border border-amber-300',
  analize_hazir: 'bg-sky-100 text-sky-800 border border-sky-300',
  eslesmeye_hazir: 'bg-[#1E3A8A] text-white',
  admin_incelemesinde: 'bg-violet-100 text-violet-800 border border-violet-300',
  eslesti: 'bg-emerald-600 text-white',
  arsivde: 'bg-zinc-100 text-zinc-500',
};

// Required field labels for UI
export const FIELD_LABELS = {
  title: 'Talep adı',
  event_type: 'Etkinlik türü',
  expected_attendees: 'Beklenen katılımcı sayısı',
  preferred_districts: 'Tercih edilen ilçeler',
  preferred_days: 'Tercih edilen günler',
  preferred_time_ranges: 'Tercih edilen saat aralıkları',
  venue_budget_model: 'Bütçe modeli',
  technical_needs: 'Teknik ihtiyaçlar',
  alcohol_needed: 'Alkol gerekli',
  outside_materials_needed: 'Dışarıdan malzeme',
  table_setup_needed: 'Masa düzeni gerekli',
  needs_two_person_table_setup: '2 kişilik masa düzeni',
  min_table_size_expectation: 'Min. masa ölçüsü',
  needs_personal_workspace: 'Kişisel çalışma alanı',
  avg_ticket_price: 'Ortalama bilet fiyatı',
  notes: 'Notlar',
};
